import { render, staticRenderFns } from "./HistoricOrders.vue?vue&type=template&id=06b01794"
import script from "./HistoricOrders.vue?vue&type=script&lang=js"
export * from "./HistoricOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports